import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=47861f3b&scoped=true&"
import script from "./Developer.vue?vue&type=script&lang=ts&"
export * from "./Developer.vue?vue&type=script&lang=ts&"
import style0 from "./Developer.vue?vue&type=style&index=0&id=47861f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47861f3b",
  null
  
)

export default component.exports